/* eslint-disable camelcase */
import type { AxiosError } from 'axios'

import axios from 'axios'

import env from 'env'

import { request } from '../request'
import { extractResponseData } from '../utils'

export type PublicListingDataToRCM = {
  id: string
  address: string
}

interface IPostLeadRCMBody {
  email?: string
  // eslint-disable-next-line @typescript-eslint/naming-convention
  owner_id: string
  firstName?: string
  mobileNumber?: string
  source: string
  property?: PublicListingDataToRCM
  automated: boolean
}

const rcmApiInstance = axios.create({
  baseURL: env.RCM_API_BASE_URL,
})

rcmApiInstance.interceptors.request.use(request)
rcmApiInstance.interceptors.response.use(extractResponseData, (error: AxiosError) =>
  Promise.reject(error.response ?? error),
)

export { rcmApiInstance }

export type { IPostLeadRCMBody as PostLeadRCMBody }
